import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Fade, makeStyles } from '@material-ui/core';
import Tooltip from '../tooltip';
import { ReactComponent as RecurringIcon } from '../../../assets/icons/repeat.svg';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  icon: {
    cursor: 'default',
  },
}));

const RecurringIconTooltip = ({
  className = undefined,
  iconClass = undefined,
  text,
  isVisible,
}) => {
  const classes = useStyles();

  return (
    <Fade in={isVisible} unmountOnExit>
      <div className={classNames(classes.root, className)}>
        <Tooltip
          customIconClass={classNames(classes.icon, iconClass)}
          text={text}
          icon={RecurringIcon}
        />
      </div>
    </Fade>
  );
};

RecurringIconTooltip.propTypes = {
  className: PropTypes.string,
  iconClass: PropTypes.string,
  text: PropTypes.string.isRequired,
};

export default RecurringIconTooltip;
